/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Fields_Need_OneInputs */

const cs_property_ai_fields_need_one = /** @type {(inputs: Property_Ai_Fields_Need_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte alespoň jedno pole`)
};

const en_property_ai_fields_need_one = /** @type {(inputs: Property_Ai_Fields_Need_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select at least one field`)
};

/**
* | output |
* | --- |
* | "Select at least one field" |
*
* @param {Property_Ai_Fields_Need_OneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_fields_need_one = /** @type {((inputs?: Property_Ai_Fields_Need_OneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Fields_Need_OneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_fields_need_one(inputs)
	return cs_property_ai_fields_need_one(inputs)
});